import React, { FC } from 'react';

import { useIntl } from 'react-intl';

import { IItem } from '@rbi-ctg/menu';
import { useUIContext } from 'state/ui';

import { PricePerContainer, PricePerLine } from './price-per-unit.styled';

export interface IPricePerUnitProps {
  product: IItem;
  totalAmount: number;
  formattedPrice: string;
  isLegalRequirement?: boolean;
}

export const PricePerUnit: FC<IPricePerUnitProps> = ({
  product,
  totalAmount,
  isLegalRequirement = false,
}) => {
  const { formatCurrencyForLocale } = useUIContext();
  const { formatMessage } = useIntl();

  if (!product?.itemSize) {
    return null;
  }

  const pricePerUnit = (1 / product.itemSize) * totalAmount;

  if (pricePerUnit === 0) {
    return null;
  }

  return (
    <PricePerContainer>
      <PricePerLine data-testid="price-per-unit" $isLegalRequirement={isLegalRequirement}>
        {formatMessage(
          { id: 'pricePerUnit' },
          {
            price: formatCurrencyForLocale(pricePerUnit),
            unit: product.itemUnit,
          }
        )}
      </PricePerLine>
    </PricePerContainer>
  );
};
